import ProcoDocsTab from "../../../../patient/details/procodocs/ProcoDocsTab";

export default function ProcoDocsDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <ProcoDocsTab inWorkQ={inWorkQ} />
    </div>
}
